import type { HelpFile } from '../../types/help'
import { ScriptExecuteLogPageTestIds } from '../../../testids/ScriptExecuteLogPageTestIds'

export const scriptExecuteLogPageHelp: HelpFile = {
  docPage: '/docs/admin/script-execute-log',
  texts: {
    [ScriptExecuteLogPageTestIds.scriptExecuteLogPage]:
      'Forensisches Prüfprotokoll jedes sql.execute()-Aufrufs (DDL) aus Skripten — sowohl Vorschau-Probeläufe als auch echte Laufzeitausführungen. PostgreSQL-Audit-Trigger reagieren nicht auf DDL, daher ist dieses Protokoll der einzige Nachweis für CREATE/DROP/ALTER/TRUNCATE-Operationen.',
    [ScriptExecuteLogPageTestIds.scriptExecuteLogFilters]: null,
    [ScriptExecuteLogPageTestIds.filterActor]:
      'Auf einen einzelnen Benutzer filtern, der das SQL ausgeführt hat. Sowohl Vorschau- als auch Laufzeitzeilen erfassen den ausführenden Benutzer.',
    [ScriptExecuteLogPageTestIds.filterMode]:
      'Nach Ausführungsmodus filtern. `Vorschau` ist ein zurückgerollter `SQL testen`-Probelauf; `Laufzeit` ist eine echte Ausführung innerhalb eines geplanten Job-Laufs.',
    [ScriptExecuteLogPageTestIds.filterSuccess]:
      'Nach Ergebnis filtern — nur erfolgreiche oder nur fehlgeschlagene Ausführungen anzeigen.',
    [ScriptExecuteLogPageTestIds.filterOccurredFrom]:
      'Nur Ausführungen ab diesem Zeitpunkt anzeigen.',
    [ScriptExecuteLogPageTestIds.filterOccurredTo]:
      'Nur Ausführungen bis zu diesem Zeitpunkt anzeigen.',
    [ScriptExecuteLogPageTestIds.clearFilters]: null,
    [ScriptExecuteLogPageTestIds.colOccurredAt]:
      'Wann die SQL-Ausführung gestartet wurde (Serverzeit).',
    [ScriptExecuteLogPageTestIds.colMode]:
      '`Vorschau` (zurückgerollter Probelauf) oder `Laufzeit` (echte Ausführung innerhalb eines Jobs).',
    [ScriptExecuteLogPageTestIds.colActor]:
      'Der Benutzer, der das SQL ausgeführt hat. Denormalisiert — bleibt erhalten, selbst wenn der Benutzer später gelöscht wird.',
    [ScriptExecuteLogPageTestIds.colSqlText]:
      'Das ausgeführte rohe SQL, hier gekürzt — öffnen Sie die Zeile für den vollständigen Text. Vermeiden Sie eingebettete Geheimnisse als Literale; sie werden wörtlich gespeichert.',
    [ScriptExecuteLogPageTestIds.colDurationMs]:
      'Wall-Clock-Zeit der SQL-Ausführung in Millisekunden (nur der JDBC-Aufruf — ohne Netzwerk und Serialisierung).',
    [ScriptExecuteLogPageTestIds.colSuccess]:
      'Ob die Ausführung ohne Fehler abgeschlossen wurde.',
    [ScriptExecuteLogPageTestIds.colErrorCode]:
      'Bei fehlgeschlagenen Ausführungen der Fehlerkategorie-Code (z. B. `SQL_PREVIEW_LIMIT_EXCEEDED`). Leer bei erfolgreichen Zeilen.',
    [ScriptExecuteLogPageTestIds.modePreview]: null,
    [ScriptExecuteLogPageTestIds.modeRuntime]: null,
    [ScriptExecuteLogPageTestIds.successTrue]: null,
    [ScriptExecuteLogPageTestIds.successFalse]: null,
    [ScriptExecuteLogPageTestIds.scriptExecuteLogDetail]:
      'Vollständige Details zu einer einzelnen Ausführung — der vollständige SQL-Text und bei Fehlern die Fehlermeldung.',
    [ScriptExecuteLogPageTestIds.detailSqlText]:
      'Die vollständige ausgeführte SQL-Anweisung, ungekürzt.',
    [ScriptExecuteLogPageTestIds.detailErrorMessage]:
      'Die Fehlermeldung für eine fehlgeschlagene Ausführung. Leer bei erfolgreichen Zeilen.',
    [ScriptExecuteLogPageTestIds.detailClose]: null,
  },
}
